import {
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { noticeToCreditorsFlow } from "../index";
import { Formik, FormikHelpers } from "formik";
import * as Yup from "yup";
import { ScreenFlowFormButtons } from "../shared/ScreenFlowFormButtons";
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";

export enum Outcomes {
  yes_administration = "yes_administration",
  yes_testament = "yes_testament",
  no = "no",
}

interface Values {
  receivedLetters: string;
}

interface Props {
  screenData?: Record<string, string | number | boolean>[];
}

export const ReceivedLetters = ({ screenData }: Props): JSX.Element => {
  const navigate = useNavigate();
  const { screenName } = useParams();
  const currentScreen = noticeToCreditorsFlow.getCurrentFlowScreen(screenName);

  console.log(`${currentScreen} screenData: ${JSON.stringify(screenData)}`);

  const receivedLetters =
    (screenData?.length && (screenData[0]?.receivedLetters as string)) || "";

  // https://formik.org/docs/api/formik
  const formikInit = {
    values: {
      receivedLetters,
    },
    schema: Yup.object().shape({
      receivedLetters: Yup.string().required("Please select an option"),
    }),
  };

  const handleSubmit = async (
    values: Values,
    { setSubmitting, setStatus }: FormikHelpers<Values>
  ) => {
    setStatus("");
    try {
      if (!currentScreen) throw Error("couldn't determine currentScreen");

      // TODO: save to database
      // console.log(`values: ${JSON.stringify(values)}`);

      // TODO: fix
      const saved = await noticeToCreditorsFlow.saveData(currentScreen, 0, {
        receivedLetters: values.receivedLetters,
      });
      console.log(`saved: ${saved}`);

      noticeToCreditorsFlow.navigateToNext(
        currentScreen,
        values.receivedLetters,
        navigate
      );
    } catch (error) {
      setStatus("Sorry, error: " + ((error as Error)?.message || ""));
      // console.error(error);
      setSubmitting(false);
    }
  };

  return currentScreen ? (
    <FlowScreenWrapper
      title="Have you received your Letters from the Probate Court yet?"
      subTitle="Executors receive Letters of Testamentary if they are named executor of an estate in a will. They will receive Letters of Administration if there was no will."
    >
      <Formik
        initialValues={formikInit.values}
        validationSchema={formikInit.schema}
        onSubmit={handleSubmit}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          // touched,
          values,
          status,
        }) => (
          <form onSubmit={handleSubmit}>
            <Grid
              container
              spacing={2}
              sx={{
                my: 1,
              }}
            >
              <Grid item xs={12}>
                <RadioGroup
                  aria-label="receivedLetters"
                  name="receivedLetters"
                  value={values.receivedLetters}
                  onBlur={handleBlur}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value={Outcomes.yes_administration}
                    control={<Radio />}
                    label="Yes, I have received Letters of Administration"
                  />
                  <FormControlLabel
                    value={Outcomes.yes_testament}
                    control={<Radio />}
                    label="Yes, I have received Letters of Testament"
                  />
                  <FormControlLabel
                    value={Outcomes.no}
                    control={<Radio />}
                    label="No, I have not received either Letters of Administration or Letters of Testament"
                  />
                </RadioGroup>
                <Typography variant="body1" color="error">
                  {errors.receivedLetters}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <ScreenFlowFormButtons
                  isSubmitting={isSubmitting}
                  status={status}
                  onBack={() => navigate(-1)}
                />
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
